cv.PublicFundraisersCompositeView = Marionette.CompositeView.extend({
  template: cv.Templates["public/fundraisers/fundraisers_composite"],
  childViewContainer: ".fundraisers-list",
  childView: cv.PublicFundraisersRowView,
  emptyView: cv.PublicFundraisersRowEmptyView,

  events: {},

  behaviors: [
    {
      behaviorClass: cv.PaginatePublicBehavior,
    },
  ],

  childEvents: {
    show: function () {},
    render: function () {},
  },

  childViewOptions: function (model, index) {
    // do some calculations based on the model
    return {
      // Pass the current tab
    };
  },

  initialize: function (options) {
    this.mergeOptions(options, this.options);

    console.log("PublicFundraisersCompositeView initialized");
  },

  isEmpty: function (collection) {
    console.log(collection);
    if (collection.num_records > 0 || _.isUndefined(collection.num_records)) {
      return false;
    }
    if (collection.num_records == 0) {
      this.$(".pagination").remove();
      return true;
    }
  },

  attachHtml: function (collectionView, childView, index) {
    if (collectionView.isBuffering) {
      // buffering happens on reset events and initial renders
      // in order to reduce the number of inserts into the
      // document, which are expensive.
      collectionView._bufferedChildren.splice(index, 0, childView);
    } else {
      // If we've already rendered the main collection, append
      // the new child into the correct order if we need to. Otherwise
      // append to the end.
      if (!collectionView._insertBefore(childView, index)) {
        collectionView._insertAfter(childView);
      }
    }
  },

  templateHelpers: function () {
    return {};
  },

  onBeforeShow: function () {},

  onShow: function () {
    if (cv.PRELOADED.preview == true) {
      this.$(".fundraisers-list").html(
        cv.Templates["public/fundraisers/preview"]({
          items: [1, 2, 3, 4, 5],
        })
      );
    } else {
      this.collection.fetch({
        headers: {
          Apikey: cv.PRELOADED.public_api_key,
        },
        reset: true,
      });
    }
  },

  onDestroy: function () {},
});
